<template>
    <div class="nav"><img style="width: 120px;margin-left: 10px" class="img" src="../assets/logo.svg"/>
        <span class="line">⎪</span><img class="img" style="width:40px;" :src="logoUrl"/>

    <span v-if="showCert!=null" style="float: right;margin-right: 10px;color:rgba(157, 42, 50, 1)" @click="onJump">查看证书</span>
    </div>

</template>

<script>
    import store from '@/store'
    export default {
        name: "NavBar",
        props:['showCert'],
        store,
        computed:{


              logoUrl (){


                return this.$store.state.logoUrl;
            }
        },


        methods:{


            onJump(){

                this.$emit('onJump')

            }

        }
    }
</script>

<style scoped>



    .nav{
        border-bottom: 1px solid #ccc;
        position: fixed;
        width: 100%;
        background: white;
        line-height: 50px;

    }


    .img{


        vertical-align: middle;

    }

    .line{

        font-family: 'ArialMT', 'Arial';

        font-style: normal;
        font-size: 20px;
        color: #333333;
        font-weight: 400;
        text-align: center;
        line-height: normal;
        opacity: 0.2;
    }

</style>
